import BookingController from "PFApp/booking/booking_controller";
import NotFoundRoute from "PFApp/routes/not_found_route";
import {
  EnsureBookingModulePermission,
  EnsureLoggedIn,
  EnsureRegistrationComplete,
  WithLayout
} from "PFApp/routes/route_helpers";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

const BookingRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <EnsureLoggedIn>
      <EnsureRegistrationComplete>
        <EnsureBookingModulePermission>
          <WithLayout>
            <Switch>
              <Route exact path={path}>
                <BookingController />
              </Route>
              <Route path={`${path}/overview`}>
                <BookingController section="overview" />
              </Route>
              <Route path={`${path}/approvals`}>
                <BookingController section="approvals" />
              </Route>
              <Route path={`${path}/reports`}>
                <BookingController section="reports" />
              </Route>
              <Route path="*">
                <NotFoundRoute />
              </Route>
            </Switch>
          </WithLayout>
        </EnsureBookingModulePermission>
      </EnsureRegistrationComplete>
    </EnsureLoggedIn>
  );
};

export default BookingRoutes;
